import {configureStore, Action, Middleware} from '@reduxjs/toolkit'
import { ThunkAction } from 'redux-thunk'
import rootReducer, {RootState} from "./rootReducer";
import { stopLoading } from './Loading_Slice';

// Track active loading timeouts to prevent memory leaks
const loadingTimeouts = new Map<string, number>();

// Loading safety timeout middleware - prevents infinite loading state
const loadingSafetyMiddleware: Middleware = (store) => (next) => (action) => {
    const result = next(action);

    // When a loading operation starts, set a 30-second safety timeout
    if (action.type === 'Loading/startLoading') {
        // Clear any existing timeout for this loading operation
        const existingTimeout = loadingTimeouts.get('loading');
        if (existingTimeout) {
            clearTimeout(existingTimeout);
        }

        // Create new timeout and store its ID
        const timeoutId = setTimeout(() => {
            const state = store.getState() as RootState;
            // If still loading after 30 seconds, force it to stop
            if (state.Loading.loading) {
                console.error('⚠️ SAFETY: Loading timeout after 30s - forcing stop');
                store.dispatch(stopLoading({ success: false, error: 'Request timeout after 30 seconds' }));
            }
            // Clean up timeout from map
            loadingTimeouts.delete('loading');
        }, 30000); // 30 seconds

        // Store timeout ID
        loadingTimeouts.set('loading', timeoutId);
    }

    // When loading stops, clear the safety timeout to prevent memory leak
    if (action.type === 'Loading/stopLoading') {
        const timeoutId = loadingTimeouts.get('loading');
        if (timeoutId) {
            clearTimeout(timeoutId);
            loadingTimeouts.delete('loading');
        }
    }

    return result;
};

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(loadingSafetyMiddleware)
});

if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./rootReducer', () => {
        const newRootReducer = require('./rootReducer').default
        store.replaceReducer(newRootReducer)
    })
}

export type AppDispatch = typeof store.dispatch

export type AppThunk = ThunkAction<void, RootState, null, Action<string>>

export default store






